export default "__VITE_ASSET__b3c74daf__"